import React from 'react';
import DarkMode from './components/DarkMode';
import Navbar from './components/Navbar';
import DateAndTime from './components/DateAndTime';
import Todos from './components/Todos';
import About from './components/About';
import ContactPage from './components/ContactPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <DarkMode>
          <Navbar />
          <b>{<DateAndTime />}</b>
          <Routes>
            <Route path='/' element={<Todos />} />

            <Route path='/about' element={<About />} />

            <Route path='/contact' element={<ContactPage />} />
          </Routes>
        </DarkMode>
      </BrowserRouter>
    </div>
  );
}

export default App;
